import { getPath } from '@/router/common'

// 支持动态配置的各个费用模型的价格体系 路由配置
const baseUrl = {
  title: '价格体系',
  path: 'newPriceStandard'
}

export default [
  {
    path: getPath('customerStandard', baseUrl),
    name: 'customerStandard',
    component: () => import(/* webpackChunkName: "customerStandard" */ '@/views/newPriceStandard/customerStandard/index.vue'),
    meta: {
      title: '客户运价标准'
    }
  },

  {
    path: getPath('customSceneList', baseUrl),
    name: 'customSceneList',
    component: () => import(/* webpackChunkName: "customSceneList" */ '@/views/newPriceStandard/customSceneList/index.vue'),
    meta: {
      title: '价格配置场景列表'
    }
  },

  // 新版价格体系配置页
  {
    path: getPath('configPriceStandardData', baseUrl),
    name: 'configPriceStandardData',
    component: () => import(/* webpackChunkName: "configPriceStandardData" */ '@/views/newPriceStandard/configPriceStandardData/index.vue'),
    meta: {
      title: '新标准价格体系配置页'
    }
  },

  // 价格体系明细数据页
  {
    path: getPath('priceStandardListDetail', baseUrl),
    name: 'priceStandardListDetail',
    component: () => import( /* webpackChunkName: "priceStandardListDetail" */ '@/views/newPriceStandard/priceStandardListDetail/index.vue'),
    meta: {
      title: '客户运价标准明细'
    }
  },

  // 价格体系编辑页
  {
    path: getPath('priceStandardEditList', baseUrl),
    name: 'priceStandardEditList',
    component: () => import( /* webpackChunkName: "priceStandardEditList" */ '@/views/newPriceStandard/priceStandardEditList/index.vue'),
    meta: {
      title: '客户运价标准明细'
    }
  },

  // 发货单位基础信息维护
  // 90080定制
  {
    path: getPath('shippercompanySetting', baseUrl),
    name: 'shippercompanySetting',
    component: () => import( /* webpackChunkName: "shippercompanySetting" */ '@/views/newPriceStandard/shippercompanySetting/index.vue'),
    meta: {
      title: '发货单位基础信息维护'
    }
  },
]
